import { render, staticRenderFns } from "./AlertWrapper.vue?vue&type=template&id=55eafd86"
import script from "./AlertWrapper.vue?vue&type=script&lang=js"
export * from "./AlertWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports